import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Search, SlidersHorizontal, CheckCircle2, Settings2, Eye, Pencil, Trash2, ChevronLeft, ChevronRight } from 'lucide-react';
// Sample data
const initialCampaigns = [{
  id: 1,
  nome: 'Newsletter Maggio 2025',
  destinatari: 'Tutti i vincitori 2025',
  inviatoDa: 'Mario Rossi',
  dataInizio: '01/05/2025',
  dataFine: '31/05/2025',
  stato: 'sent'
}, {
  id: 2,
  nome: 'Campagna Estate 2025',
  destinatari: 'Utenti Yopmail (Test)',
  inviatoDa: 'Laura Bianchi',
  dataInizio: '01/06/2025',
  dataFine: '30/06/2025',
  stato: 'draft'
}, {
  id: 3,
  nome: 'Aggiornamento Bandi Q2',
  destinatari: 'Tutti gli utenti (soggetti proponenti)',
  inviatoDa: 'Mario Rossi',
  dataInizio: '15/04/2025',
  dataFine: '15/04/2025',
  stato: 'sent'
}, {
  id: 4,
  nome: 'Invito Webinar Luglio',
  destinatari: 'Utenti Yopmail (Test)',
  inviatoDa: 'Giulia Verdi',
  dataInizio: '10/07/2025',
  dataFine: '10/07/2025',
  stato: 'draft'
}, {
  id: 5,
  nome: 'Reminder Scadenze Aprile',
  destinatari: 'Tutti gli utenti (soggetti proponenti)',
  inviatoDa: 'Laura Bianchi',
  dataInizio: '05/04/2025',
  dataFine: '05/04/2025',
  stato: 'sent'
}, {
  id: 6,
  nome: 'Campagna Autunno 2025',
  destinatari: 'Utenti Yopmail (Test)',
  inviatoDa: 'Mario Rossi',
  dataInizio: '01/09/2025',
  dataFine: '30/09/2025',
  stato: 'draft'
}, {
  id: 7,
  nome: 'Newsletter Marzo 2025',
  destinatari: 'Tutti i vincitori 2025',
  inviatoDa: 'Giulia Verdi',
  dataInizio: '01/03/2025',
  dataFine: '31/03/2025',
  stato: 'sent'
}, {
  id: 8,
  nome: 'Comunicazione Vincitori',
  destinatari: 'Utenti Yopmail (Test)',
  inviatoDa: 'Mario Rossi',
  dataInizio: '20/06/2025',
  dataFine: '20/06/2025',
  stato: 'draft'
}, {
  id: 9,
  nome: 'Aggiornamento Piattaforma',
  destinatari: 'Tutti gli utenti (soggetti proponenti)',
  inviatoDa: 'Laura Bianchi',
  dataInizio: '12/03/2025',
  dataFine: '12/03/2025',
  stato: 'sent'
}, {
  id: 10,
  nome: 'Campagna Rendicontazione',
  destinatari: 'Utenti Yopmail (Test)',
  inviatoDa: 'Giulia Verdi',
  dataInizio: '15/07/2025',
  dataFine: '31/07/2025',
  stato: 'draft'
}];
export function EmailCampagne() {
  const [searchQuery, setSearchQuery] = useState('');
  const [filters, setFilters] = useState({
    nome: '',
    destinatari: '',
    inviatoDa: '',
    dataInizio: '',
    dataFine: '',
    stato: 'TUTTI'
  });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // Filter logic
  const filteredData = initialCampaigns.filter(item => {
    const matchesSearch = item.nome.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesFilters = item.nome.toLowerCase().includes(filters.nome.toLowerCase()) && item.destinatari.toLowerCase().includes(filters.destinatari.toLowerCase()) && item.inviatoDa.toLowerCase().includes(filters.inviatoDa.toLowerCase()) && item.dataInizio.toLowerCase().includes(filters.dataInizio.toLowerCase()) && item.dataFine.toLowerCase().includes(filters.dataFine.toLowerCase()) && (filters.stato === 'TUTTI' || item.stato === filters.stato);
    return matchesSearch && matchesFilters;
  });
  const handleFilterChange = (key: string, value: string) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };
  return <div className="space-y-6 font-roboto" data-id="element-922">
      {/* Page Header */}
      <div className="bg-white px-6 py-4 flex items-center justify-between" style={{
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      borderRadius: '8px'
    }} data-id="element-923">
        <h1 className="text-2xl font-normal text-[#293B54] font-roboto" data-id="element-924">
          Campagne
        </h1>
        <Button className="bg-[#293B54] text-white normal-case text-sm px-4 py-2 rounded font-normal font-condensed hover:bg-[#1e2b3e] transition-colors" data-id="element-925">
          Crea nuova campagna
        </Button>
      </div>

      {/* Content Area */}
      <div className="p-6 bg-[#eff0f2]" data-id="element-926">
        <div className="bg-white" style={{
        boxShadow: 'none',
        border: '1px solid #E4E4E4',
        borderRadius: '8px',
        overflow: 'hidden'
      }} data-id="element-927">
          {/* Search Bar Row */}
          <div className="p-4 border-b border-[#E4E4E4] flex justify-between items-center" data-id="element-928">
            <div className="relative w-80" data-id="element-929">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} data-id="element-930" />
              <input type="text" placeholder="Cerca nelle campagne..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-9 pr-3 py-2 border border-[#E4E4E4] text-sm focus:outline-none focus:border-[#293B54] transition-colors" data-id="element-931" />
            </div>
            <button className="p-2 border border-[#E4E4E4] text-gray-500 hover:bg-gray-50 transition-colors" data-id="element-932">
              <SlidersHorizontal size={16} data-id="element-933" />
            </button>
          </div>

          {/* Table */}
          <div className="overflow-x-auto" data-id="element-934">
            <table className="w-full border-collapse min-w-[1000px]" data-id="element-935">
              <thead data-id="element-936">
                <tr className="border-b border-[#E4E4E4]" style={{
                backgroundColor: '#FFFFFF'
              }} data-id="element-937">
                  <th className="py-3 px-4 text-left text-xs font-medium text-[#293B54] uppercase tracking-wider" data-id="element-938">
                    Nome Campagna
                  </th>
                  <th className="py-3 px-4 text-left text-xs font-medium text-[#293B54] uppercase tracking-wider" data-id="element-939">
                    Destinatari
                  </th>
                  <th className="py-3 px-4 text-left text-xs font-medium text-[#293B54] uppercase tracking-wider" data-id="element-940">
                    Inviato Da
                  </th>
                  <th className="py-3 px-4 text-left text-xs font-medium text-[#293B54] uppercase tracking-wider" data-id="element-941">
                    Data Inizio
                  </th>
                  <th className="py-3 px-4 text-left text-xs font-medium text-[#293B54] uppercase tracking-wider" data-id="element-942">
                    Data Fine
                  </th>
                  <th className="py-3 px-4 text-left text-xs font-medium text-[#293B54] uppercase tracking-wider" data-id="element-943">
                    Stato
                  </th>
                  <th className="py-3 px-4 text-left text-xs font-medium text-[#293B54] uppercase tracking-wider" data-id="element-944">
                    Azioni
                  </th>
                </tr>

                {/* Filter Row */}
                <tr className="bg-[#F4F4F4] border-b border-[#E4E4E4]" data-id="element-945">
                  <td className="p-2" data-id="element-946">
                    <input type="text" value={filters.nome} onChange={e => handleFilterChange('nome', e.target.value)} className="w-full border border-[#E4E4E4] px-2 py-1 text-xs focus:outline-none focus:border-[#293B54]" data-id="element-947" />
                  </td>
                  <td className="p-2" data-id="element-948">
                    <input type="text" value={filters.destinatari} onChange={e => handleFilterChange('destinatari', e.target.value)} className="w-full border border-[#E4E4E4] px-2 py-1 text-xs focus:outline-none focus:border-[#293B54]" data-id="element-949" />
                  </td>
                  <td className="p-2" data-id="element-950">
                    <input type="text" value={filters.inviatoDa} onChange={e => handleFilterChange('inviatoDa', e.target.value)} className="w-full border border-[#E4E4E4] px-2 py-1 text-xs focus:outline-none focus:border-[#293B54]" data-id="element-951" />
                  </td>
                  <td className="p-2" data-id="element-952">
                    <input type="text" value={filters.dataInizio} onChange={e => handleFilterChange('dataInizio', e.target.value)} className="w-full border border-[#E4E4E4] px-2 py-1 text-xs focus:outline-none focus:border-[#293B54]" data-id="element-953" />
                  </td>
                  <td className="p-2" data-id="element-954">
                    <input type="text" value={filters.dataFine} onChange={e => handleFilterChange('dataFine', e.target.value)} className="w-full border border-[#E4E4E4] px-2 py-1 text-xs focus:outline-none focus:border-[#293B54]" data-id="element-955" />
                  </td>
                  <td className="p-2" data-id="element-956">
                    <select value={filters.stato} onChange={e => handleFilterChange('stato', e.target.value)} className="w-full border border-[#E4E4E4] px-2 py-1 text-xs focus:outline-none focus:border-[#293B54] bg-white" data-id="element-957">
                      <option value="TUTTI" data-id="element-958">TUTTI</option>
                      <option value="INVIATO" data-id="element-959">INVIATO</option>
                      <option value="BOZZA" data-id="element-960">BOZZA</option>
                    </select>
                  </td>
                  <td className="p-2" data-id="element-961"></td>
                </tr>
              </thead>
              <tbody data-id="element-962">
                {filteredData.map(row => <tr key={row.id} className="bg-white border-b border-[#E4E4E4] hover:bg-gray-50 transition-colors" data-id="element-963">
                    <td className="py-3 px-4 text-sm text-[#8C919A]" data-id="element-964">
                      {row.nome}
                    </td>
                    <td className="py-3 px-4 text-sm text-[#8C919A]" data-id="element-965">
                      {row.destinatari}
                    </td>
                    <td className="py-3 px-4 text-sm text-[#8C919A]" data-id="element-966">
                      {row.inviatoDa}
                    </td>
                    <td className="py-3 px-4 text-sm text-[#8C919A]" data-id="element-967">
                      {row.dataInizio}
                    </td>
                    <td className="py-3 px-4 text-sm text-[#8C919A]" data-id="element-968">
                      {row.dataFine}
                    </td>
                    <td className="py-3 px-4 text-sm text-[#8C919A]" data-id="element-969">
                      {row.stato === 'sent' ? <div className="flex items-center gap-1 text-[#22c55e] text-xs font-medium" data-id="element-970">
                          <CheckCircle2 size={16} data-id="element-971" />
                          <span data-id="element-972">Inviato</span>
                        </div> : <div className="flex items-center gap-1 text-[#80858E] text-xs font-medium" data-id="element-973">
                          <Settings2 size={16} data-id="element-974" />
                          <span data-id="element-975">Bozza</span>
                        </div>}
                    </td>
                    <td className="py-3 px-4 text-sm text-[#8C919A]" data-id="element-976">
                      {row.stato === 'sent' ? <button className="text-[#80858E] hover:text-[#293B54] transition-colors p-1" data-id="element-977">
                          <Eye size={16} data-id="element-978" />
                        </button> : <div className="flex items-center gap-2" data-id="element-979">
                          <button className="text-[#80858E] hover:text-[#293B54] transition-colors p-1" data-id="element-980">
                            <Pencil size={16} data-id="element-981" />
                          </button>
                          <button className="text-[#80858E] hover:text-[#293B54] transition-colors p-1" data-id="element-982">
                            <Eye size={16} data-id="element-983" />
                          </button>
                          <button className="text-[#80858E] hover:text-red-600 transition-colors p-1" data-id="element-984">
                            <Trash2 size={16} data-id="element-985" />
                          </button>
                        </div>}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="flex items-center justify-end gap-4 px-4 py-3 border-t border-[#E4E4E4]" data-id="element-986">
            <div className="flex items-center gap-2 text-sm text-[#444444]" data-id="element-987">
              <span data-id="element-988">Righe per pagina:</span>
              <select value={rowsPerPage} onChange={e => setRowsPerPage(Number(e.target.value))} className="border-none bg-transparent font-medium focus:outline-none cursor-pointer" data-id="element-989">
                <option value={10} data-id="element-990">10</option>
                <option value={25} data-id="element-991">25</option>
                <option value={50} data-id="element-992">50</option>
              </select>
            </div>
            <span className="text-sm text-[#80858E]" data-id="element-993">
              1-{filteredData.length} di 26
            </span>
            <div className="flex items-center gap-1" data-id="element-994">
              <button disabled className="p-1 text-[#80858E] opacity-50 cursor-not-allowed" data-id="element-995">
                <ChevronLeft size={20} data-id="element-996" />
              </button>
              <button className="p-1 text-[#293B54] hover:bg-gray-100 rounded transition-colors" data-id="element-997">
                <ChevronRight size={20} data-id="element-998" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}